import React from "react";

const Header = () => {
  return (
    <section>
      <nav className="navbar">
        <img
          src="https://img.icons8.com/plasticine/100/000000/dog.png"
          alt="dog icon"
        />
        <h1>An image gallery of awesome dogs </h1>
      </nav>
    </section>
  );
};

export default Header;
